<template>
  <!--Evento emitido quando o snackbar é aberto ou fechado
      @event input
      @property {Boolean} opened - Indica se o snackbar está aberto ou não
   -->
  <v-snackbar
    class="zoox-component zoox-snackbar"
    max-width="345px"
    :color="color"
    :value="opened"
    :vertical="isVertical"
    :bottom="bottom"
    :top="top"
    :left="left"
    :right="right"
    :centered="centered"
    :timeout="-1"
    @input="$emit('input', $event)"
  >
    <span class="zoox-snackbar-text">
      {{ text }}
    </span>
    <template
      v-if="confirmation || $scopedSlots['action']"
      v-slot:action="{attrs}"
    >
      <!--@slot Slot para custmização da ação do componente-->
      <slot name="action">
        <v-btn
          class="zoox-snackbar-btn"
          color="var(--white)"
          text
          small
          v-bind="attrs"
          @click="onConfirm"
        >
          {{ confirmationText }}
        </v-btn>
      </slot>
    </template>
  </v-snackbar>
</template>

<script>
/**
 * @displayName Snackbar
 */
export default {
  name: 'ZSnackbar',
  model: {
    prop: 'opened',
    event: 'input',
  },
  props: {
    /**
     * Texto do snackbar
     */
    text: {
      type: String,
      required: true,
    },
    /**
     * Texto do botão de confirmação do snackbar
     */
    confirmationText: {
      type: String,
      required: false,
      default: 'ok',
    },
    /**
     * Flag para indicar que deve ter um botão de confirmação
     */
    confirmation: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar se o item está aberto
     *
     * @modelName opened
     */
    opened: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Flag para escolher a cor do zSnackBar
     */
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    /**
     * Flag para posicionar o snackbar na parte inferior.
     */
    bottom: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para posicionar o snackbar no centro da tela(eixos x e y).
     */
    centered: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para posicionar o snackbar na esquerda.
     */
    left: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para posicionar o snackbar na direita.
     */
    right: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para posicionar o snackbar na parte superior.
     */
    top: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVertical() {
      return this.confirmation && this.confirmationText.length >= 6
    },
  },
  methods: {
    onConfirm() {
      /**
       * Evento disparado quando o botão de confirmação é clicado
       */
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
.zoox-snackbar {
  .v-snack__wrapper {
    border-radius: var(--zoox-snackbar-radius);
  }
}
</style>
